/**
 * Componente que protege las rutas a las que no se debe poder acceder si no se está loggeado.
 * Se incluye en App.js y utiliza el contexto de autenticación para mostrar o no el componente.
**/

import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) return <p>Loading...</p>;
  //Si el contexto no retorna un user autenticado, navega a login. Si no, muestra el componente
  //que este componente envuelve
  return user ? children : <Navigate to="/login" />;
};

export default ProtectedRoute;